(() => {
  if (window.ampLocalizationReady) return;
  const node = document.getElementById('AmpMarketConfig');
  const form = document.getElementById('AmpCountryForm');
  const dialog = document.getElementById('AmpCountryDialog');
  if (!node || !form || !dialog) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch { return; }
  const select = form.querySelector('[name="country_code"]');
  if (!select || !Array.isArray(config.countries)) return;
  window.ampLocalizationReady = true;
  const supported = code => typeof code === 'string' && config.countries.includes(code);
  const readCookie = name => {
    try {
      const value = document.cookie.split('; ').find(item => item.startsWith(name + '='));
      return value ? decodeURIComponent(value.slice(name.length + 1)) : '';
    } catch { return ''; }
  };
  const writeCookie = (name, value, age) => {
    try { document.cookie = name + '=' + encodeURIComponent(value) + '; Max-Age=' + age + '; Path=/; SameSite=Lax; Secure'; } catch {}
  };
  const sessionRead = key => {
    try { return window.sessionStorage.getItem(key) || ''; } catch { return ''; }
  };
  const sessionWrite = (key, value) => {
    try { window.sessionStorage.setItem(key, value); } catch {}
  };
  const forget = key => {
    try { window.sessionStorage.removeItem(key); } catch {}
    writeCookie(key, '', 0);
  };
  // Country overrides are session-scoped. Permanent cookies used to pin old
  // markets, so a US visitor could keep seeing AUD after changing their IP.
  const readRecord = key => {
    try { return JSON.parse(sessionRead(key) || 'null'); } catch { return null; }
  };
  const saveRecord = (key, value) => {
    const record = JSON.stringify(value);
    sessionWrite(key, record);
    return sessionRead(key) === record;
  };
  const choiceKey = 'amp_market_manual_session_v5';
  const attemptKey = 'amp_market_attempt_session_v5';
  // Previous choices had no location attached and could prevent all future detection.
  forget('amp_market_manual_v2');
  forget('amp_market_attempt_v2');
  // Reset old geo-less selections that could pin AUD even after US IP detection.
  forget('amp_market_manual_v3');
  forget('amp_market_attempt_v3');
  forget('amp_market_manual_v4');
  forget('amp_market_attempt_v4');
  let detectedGeo = '';
  const remember = code => {
    if (!supported(code)) return;
    manualAction++;
    saveRecord(choiceKey, { country: code, geo: detectedGeo || sessionRead('amp_last_geo_v5'), savedAt: Date.now() }, 2592000);
  };
  const destination = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('country');
    return url.pathname + url.search + url.hash;
  };
  const setReturnPath = targetForm => {
    const fields = [...targetForm.querySelectorAll('[name="return_to"]')];
    let field = fields[0];
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'return_to';
      targetForm.appendChild(field);
    }
    field.value = destination();
    fields.slice(1).forEach(extra => extra.remove());
  };
  let manualAction = 0;
  let engaged = false;
  let switching = false;
  let opener;
  const openDialog = button => {
    opener = button || document.activeElement;
    select.value = config.country;
    if (!dialog.open) dialog.showModal();
  };
  const updateCountry = (code, manual) => {
    if (!supported(code) || switching) return;
    if (manual) remember(code);
    select.value = code;
    setReturnPath(form);
    switching = true;
    HTMLFormElement.prototype.submit.call(form);
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-amp-market-open]');
    if (button) openDialog(button);
    if (event.target.closest('[data-amp-market-close]')) dialog.close();
    const option = event.target.closest('localization-form [data-value]');
    const countryForm = option?.closest('form');
    if (countryForm?.querySelector('[name="country_code"]') && supported(option.dataset.value)) {
      remember(option.dataset.value);
      setReturnPath(countryForm);
    }
  }, true);
  document.addEventListener('submit', event => {
    const targetForm = event.target;
    const countryField = targetForm.querySelector?.('[name="country_code"]');
    if (countryField) {
      remember(countryField.value);
      setReturnPath(targetForm);
    }
    if (targetForm.closest?.('product-form') || targetForm.id === 'cart' || targetForm.id === 'CartDrawer-Form') engaged = true;
  }, true);
  document.addEventListener('change', event => {
    const targetForm = event.target.closest('form[action*="/localization"]');
    if (targetForm && targetForm !== form && event.target.name === 'country_code') {
      remember(event.target.value);
      setReturnPath(targetForm);
    }
  }, true);
  document.addEventListener('pointerdown', event => {
    if (event.target.closest('product-form,variant-selects,quantity-input,input,textarea,select,[contenteditable="true"]')) engaged = true;
  }, { capture: true, passive: true });
  document.addEventListener('input', () => { engaged = true; }, { once: true, capture: true });
  dialog.addEventListener('close', () => opener?.focus());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  setReturnPath(form);
  if (config.designMode || /bot|crawl|spider|lighthouse/i.test(navigator.userAgent)) return;
  const explicitCountry = new URL(window.location.href).searchParams.get('country')?.toUpperCase();
  if (supported(explicitCountry)) {
    remember(explicitCountry);
    if (explicitCountry !== config.country) {
      updateCountry(explicitCountry, false);
      return;
    }
    try { window.history.replaceState(window.history.state, '', destination()); } catch {}
  }
  // Automatic geolocation is silent; only user-initiated country selection opens the dialog.
  let busy = false;
  let lastCheck = 0;
  let failures = 0;
  let recheckPending = false;
  let locationRevision = 0;
  const detectCountry = async (force = false) => {
    if (switching || document.visibilityState === 'hidden') return;
    if (busy) {
      if (force) recheckPending = true;
      return;
    }
    if (!force && lastCheck && Date.now() - lastCheck < 10000) return;
    busy = true;
    lastCheck = Date.now();
    const manualAtStart = manualAction;
    const revisionAtStart = locationRevision;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 6000);
    try {
      // Country-detection service is at the store root, not the locale subfolder.
      const url = new URL('/browsing_context_suggestions.json', window.location.origin);
      url.searchParams.set('country[enabled]', 'true');
      url.searchParams.set('country[exclude]', config.country);
      url.searchParams.set('_amp_location_check', String(Date.now()));
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('Country lookup unavailable');
      const data = await response.json();
      if (revisionAtStart !== locationRevision) return;
      failures = 0;
      const detected = data.detected_values?.country;
      const suggestion = data.suggestions?.find(item => supported(item.parts?.country?.handle));
      const target = detected?.handle ? detected : suggestion?.parts?.country;
      if (!target?.handle) return;
      const confidence = Number(suggestion?.parts?.country?.confidence || suggestion?.confidence || 0);
      if (!detected?.handle && confidence < 0.9) return;
      detectedGeo = target.handle;
      sessionWrite('amp_last_geo_v5', detectedGeo);
      const choice = readRecord(choiceKey);
      const validChoice = supported(choice?.country) && choice.geo === detectedGeo && Number.isFinite(choice.savedAt) && Date.now() - choice.savedAt < 2592000000;
      if (manualAction !== manualAtStart) return;
      let preferred = '';
      if (validChoice) {
        preferred = choice.country;
      } else if (choice) {
        // A new IP country releases the old manual choice, including VPN tests.
        forget(choiceKey);
      }
      // Never switch to a country Shopify has not enabled for this store.
      if (!preferred && !supported(detectedGeo)) return;
      const country = preferred || detectedGeo;
      if (country === config.country) {
        forget(attemptKey);
        return;
      }
      const previous = readRecord(attemptKey);
      const repeated = previous?.from === config.country && previous.to === country && previous.geo === detectedGeo && Date.now() - Number(previous.at) < 15000;
      // Avoid interrupting a visitor who has already started shopping.
      if (engaged || repeated) return;
      const guard = { from: config.country, to: country, geo: detectedGeo, at: Date.now() };
      // Do not block an otherwise valid redirect when the browser rejects cookies/storage.
      saveRecord(attemptKey, guard, 20);
      updateCountry(country, false);
    } catch {
      if (failures++ === 0) {
        lastCheck = 0;
        setTimeout(detectCountry, 900);
      }
    } finally {
      clearTimeout(timeout);
      busy = false;
      if (recheckPending) {
        recheckPending = false;
        detectCountry(true);
      }
    }
  };
  const resumeDetection = () => {
    locationRevision++;
    detectCountry(true);
  };
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') resumeDetection();
  });
  window.addEventListener('pageshow', event => { if (event.persisted) resumeDetection(); });
  window.addEventListener('focus', resumeDetection);
  window.addEventListener('online', resumeDetection);
  detectCountry();
})();
